import { CIcon } from '~/icons/types'

export const ciRefresh: CIcon = {
  width: '17',
  height: '17',
  paths: [
    {
      d:
        'M14.603 10.071c-.333-.133-.733 0-.867.4-.266.667-.666 1.2-1.133 1.734-2 2-5.266 2-7.333 0-2-2-2-5.267 0-7.334 1.667-1.666 4.133-2 6.133-.933h-.466c-.4 0-.667.267-.667.667s.267.666.667.666h2.733c.066 0 .066 0 .133-.066.067 0 .067-.067.133-.067.067 0 .067-.067.067-.067s.067-.066.067-.133.066-.067.066-.133V4.47l-.333-2.266c-.067-.334-.4-.6-.733-.534-.334.067-.6.4-.534.734l.067.666c-2.533-1.666-6-1.4-8.266.8-2.534 2.534-2.534 6.667 0 9.2a6.52 6.52 0 0 0 4.6 1.934 6.52 6.52 0 0 0 4.6-1.934c.6-.6 1.133-1.333 1.466-2.2.133-.266-.066-.666-.4-.8Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'refresh',
  type: 'regular'
}
